import vue from 'vue'

function getCompanylist () {
  const url = 'security/company/getcompanylist'
  return vue.axios.post(url, {}).then((res) => {
    return Promise.resolve(res.data)
  })
}

function getCompanyDetail (companyid) {
  const url = 'security/company/getcompanydetail'
  return vue.axios.post(url, {
    reqdata: {
      companyid
    }
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}
export {
  getCompanylist,
  getCompanyDetail
}



// WEBPACK FOOTER //
// ./src/api/main.js